import Vue from 'vue'

// lazy component loading
const List = () => import(/* webpackChunkName: "users" */ './List.vue');
const User = () => import(/* webpackChunkName: "users" */ './User.vue');
const Segmentation = () => import(/* webpackChunkName: "users" */ './Segmentation.vue');
const Segment = () => import(/* webpackChunkName: "users" */ './Segment.vue');

//ROUTES
export const routes = [{
  path: '/users',
  redirect: '/users/list',
  name: 'users',
  //empty component just for base
  component: {template: '<router-view/>'},
  meta: {
    trans: 'titles.users',
    icon: 'users',
  },
  children: [
    {
      path: 'list',
      name: 'users.list',
      component: List,
      meta: {
        trans: 'users:list',
        menu: true,
        icon: 'info-round',
      },
    },
    {
      path: 'list/:id',
      name: 'users.show',
      component: User,
      meta: {
        trans: 'users:user',
        up: 'users.list',
      },
    },
    {
      path: 'segmentation',
      name: 'users.segmentation',
      component: Segmentation,
      meta: {
        trans: 'users:segments.title',
        menu: true,
        icon: 'piechart',
      },
    },
    {
      path: 'segmentation/:id',
      name: 'users.segmentation.show',
      component: Segment,
      props: true,
      meta: {
        trans: 'users:segments.title',
      },
    }
  ],
}];

// TRANSLATIONS
import en from './i18n/en'
import it from './i18n/it'
import sl from './i18n/sl'
import de from './i18n/de'
import fr from './i18n/fr'
import i18n from '@/providers/i18n'

for (let [lang, bundle] of Object.entries({en, it, sl, de, fr})) {
  i18n.i18next.addResourceBundle(lang, 'users', bundle);
}


// WEBPACK FOOTER //
// ./src/sections/users/index.js